export enum SocketEvent {
  ChatMessageReceived = 'chat:message_received',
  NotificationReceived = 'notification',
  GetAllChannelMessages = 'chat:message_history',
  ParticipantLastSeenUpdated = 'chat:participant_last_seen_updated',
  MessageDeleted = 'chat:message_deleted',
}
